import { Lock, ShieldCheck } from "lucide-react";
import type { Translate } from "../i18n";

// The interstitial shown after Pay while we mint the Stripe session and redirect.
// A CLEAN, lightweight CSS 3D-printer loader — NOT the buggy Three.js mockup.
export function Redirecting({ t }: { t: Translate }) {
  return (
    <main className="co-center" aria-live="polite" aria-busy="true">
      <div className="co-printer" aria-hidden>
        <div className="co-printer-frame" />
        <div className="co-printer-gantry">
          <div className="co-printer-nozzle" />
        </div>
        <div className="co-printer-build" />
        <div className="co-printer-bed" />
      </div>
      <h1>{t("redirect.title")}</h1>
      <p>{t("redirect.subtitle")}</p>
      <div className="co-progress" aria-hidden>
        <span />
      </div>
      <div className="co-badges">
        <span>
          <ShieldCheck size={14} aria-hidden /> {t("redirect.badgeVerified")}
        </span>
        <span>
          <Lock size={14} aria-hidden /> {t("redirect.badgeEncrypted")}
        </span>
        <span>
          <ShieldCheck size={14} aria-hidden /> {t("redirect.badgeSsl")}
        </span>
      </div>
    </main>
  );
}
